import { findIndex, isEmpty } from 'lodash'
import { observable, action } from 'mobx'
import { DATE_FORMAT_CLIENT_PARAMS, PAGE_SIZE, statusOrder } from '../helpers/constants'
import api from '../common/api'
import { Request2 } from 'src/common/Request2'
import { responseDefault } from './store.constants'
import moment from 'moment'

export class OrdersStore {
   @observable offsetList: number = 0
   @observable orders: any = { ...responseDefault }
   @observable ordersRecruiting: any = { ...responseDefault } //NEW: 0,
   @observable ordersProcessing: any = { ...responseDefault } //    DOING: 1,
   @observable ordersReview: any = { ...responseDefault } //    REVIEW: 2,
   @observable ordersEditing: any = { ...responseDefault } //    REJECT: 3,
   @observable ordersDone: any = { ...responseDefault } //    FINISH: 4,
   @observable ordersCount: any = {}
   @observable textSearch: string = ''
   @observable fieldFilter: any = {}
   @observable ordersTotal: any = {}
   @observable products: any = { ...responseDefault }
   @observable listStores: any = []
   @observable listHistory: any = []
   @observable productsSelected: any = []
   @observable orderDetail: any = {}
   @observable sellerId: any = null
   @observable dataExport: any = { ...responseDefault }
   @observable shippingFee: number = 0
   @observable listShippingData: any = []
   @observable activeTab = 'ATD'
   @observable averageDelivery: any = {}

   //LIST
   @observable startTime: any = moment().subtract(1, 'months')
   @observable endTime: any = moment()
   // const [startTime, setStartTime] = useState(moment().subtract(1, 'months'))
   // const [endTime, setEndTime] = useState(moment())
   @observable statusObj: any = {
      new: [statusOrder.NEW], //new+renew
      accepted: [statusOrder.ACCEPTED],
      assignee: [statusOrder.ASSIGNEE],
      finish: [statusOrder.FINISH],
      // renew: [statusOrder.RE_NEW],
      cancel: [statusOrder.CANCEL]
   }
   @observable listShip: any = { ...responseDefault }
   @observable draftOrderCount: number = 0

   @action
   async getShip(params: any = {}, history?: any) {
      let param = { ...params }
      console.log('param', param)
      const result = await Request2.getWithToken(api.tracking.getList, { ...param, ...{ limit: PAGE_SIZE } })
      if (!isEmpty(result)) {
         this.listShip = result
      } else {
         this.listShip = { ...responseDefault }
      }
   }

   @action
   async setActiveTab(tab: string) {
      this.activeTab = tab
   }

   //LIST
   @action
   setStartTime(value: any) {
      this.startTime = value
   }
   @action
   setEndTime(value: any) {
      this.endTime = value
   }
   @action
   setStatusObj(statusObj: any) {
      this.statusObj = { ...statusObj }
   }

   @action
   async getOrderList(params: any = {}) {
      const statusResult = [
         ...this.statusObj.new,
         ...this.statusObj.accepted,
         ...this.statusObj.assignee,
         ...this.statusObj.cancel,
         // ...statusObj.renew,
         ...this.statusObj.finish
      ].toString()

      const param = {
         ...params,
         ...{
            //TODO đơn hàng nháp draft
            status: params?.status !== undefined ? params.status : statusResult,
            from: moment(this.startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            to: moment(this.endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
         }
      }
      const result = await Request2.getWithToken(api.order.getList, { ...param, ...{ limit: PAGE_SIZE } })
      if (!isEmpty(result)) {
         this.orders = result
         this.offsetList = result.offset
      } else {
         this.orders = { ...responseDefault }
         this.offsetList = 0
      }

      return this.orders
   }

   @action
   async getDraftOrderList(params: any = {}) {
      const param = {
         ...params,
         ...{
            from: moment(this.startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            to: moment(this.endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
         }
      }
      delete param.status
      delete param.tracking_status_name

      const result = await Request2.getWithToken(api.draftOrder.getList, {
         ...param,
         ...{ status: 'draft', limit: PAGE_SIZE }
      })
      if (!isEmpty(result)) {
         this.orders = result
         this.offsetList = result.offset
      } else {
         this.orders = { ...responseDefault }
         this.offsetList = 0
      }

      return this.orders
   }

   @action
   async getDraftOrderCount() {
      try {
         const result = await Request2.getWithToken(api.draftOrder.getList, {
            status: 'draft',
            limit: 1,
            offset: 0
         })
         if (!isEmpty(result)) {
            this.draftOrderCount = result.count || 0
         } else {
            this.draftOrderCount = 0
         }
      } catch (error) {
         this.draftOrderCount = 0
      }
   }

   @action
   async getAverageDelivery(params: any = {}) {
      const statusResult = [
         ...this.statusObj.new,
         ...this.statusObj.accepted,
         ...this.statusObj.assignee,
         ...this.statusObj.cancel,
         // ...statusObj.renew,
         ...this.statusObj.finish
      ].toString()

      const param = {
         ...params,
         ...{
            status: params?.status !== undefined ? params.status : statusResult,
            from: moment(this.startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            to: moment(this.endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
         }
      }
      const result = await Request2.getWithToken(api.order.averageDeliveryTime, { ...param, ...{ limit: PAGE_SIZE } })
      if (!isEmpty(result)) {
         this.averageDelivery = result
      } else {
         this.averageDelivery = {}
      }

      return this.averageDelivery
   }

   @action
   async exportExcelV2(params: any = {}) {
      const statusResult = [
         ...this.statusObj.new,
         ...this.statusObj.accepted,
         ...this.statusObj.assignee,
         ...this.statusObj.cancel,
         // ...statusObj.renew,
         ...this.statusObj.finish
      ].toString()

      const param = {
         ...params,
         ...{
            status: params?.status !== undefined ? params.status : statusResult,
            from: moment(this.startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            to: moment(this.endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
         }
      }
      const result = await Request2.getFileWithToken(api.order.exportExcelv2, { ...param })
      return result
   }

   @action
   async getProductsList(params: any = {}) {
      const result = await Request2.getWithToken(api.products.getList, { ...params })
      if (!isEmpty(result)) {
         this.products = result
      }
   }
   @action
   async getListStores(id: string) {
      const result = await Request2.getWithToken(api.order.listStore + `/${id}`)
      if (!isEmpty(result)) {
         const dt = result.filter((it: any) => !it?.disable)
         this.listStores = dt
      }
   }

   async getListStoreMultiOrder(orderIds: any = {}) {
      const result = await Request2.getWithToken(api.order.listStoreMultiOrder, orderIds)
      if (!isEmpty(result)) {
         const dt = result.filter((it: any) => !it?.disable)
         this.listStores = dt
      }
   }

   @action
   async getProducts(params: any = {}) {
      let param = { ...params }
      // if (param?.isPriority) {
      //    param.isPriority = true
      // } else {
      //    delete param['isPriority']
      // }
      const result = await Request2.getWithToken(api.products.getList, { ...param, ...{ limit: PAGE_SIZE } })

      if (!isEmpty(result)) {
         this.products = result
      } else {
         this.products = { ...responseDefault }
      }
   }

   @action
   setProductsSelected(list: any) {
      if (list.length == 0) {
         this.productsSelected.length = 0
         return
      }
      this.productsSelected = [...list]
   }

   @action
   removeProduct(index: number) {
      this.productsSelected.splice(index, 1)
   }

   @action
   async createOrder(params: any = {}) {
      const result = await Request2.postWithToken(params, api.order.create)
      return result
   }
   @action
   async createDraftOrder(params: any = {}) {
      const result = await Request2.postWithToken(params, api.draftOrder.create)
      return result
   }
   @action
   async updateTrackingId(
      id: string,
      trackingId: string,
      saigonId?: string,
      sellerOrderId?: string,
      note?: string,
      linkDesign?: string,
      linkMockup?: string,
      phone?: string,
      note1?: string,
      listProduct?: any[]
   ) {
      let param = { trackingId, note, note1 }
      //@ts-ignore
      if (saigonId) {
         //@ts-ignore
         param.saigonId = saigonId
      }
      //@ts-ignore
      if (sellerOrderId) {
         //@ts-ignore
         param.sellerOrderId = sellerOrderId
      }

      if (linkDesign) {
         //@ts-ignore
         param.linkDesign = linkDesign
      }

      if (linkMockup) {
         //@ts-ignore
         param.linkMockup = linkMockup
      }

      if (phone) {
         //@ts-ignore
         param.phone = phone
      }

      if (listProduct && listProduct.length > 0) {
         //@ts-ignore
         param.listProduct = listProduct
      }
      const result = await Request2.postWithToken(param, api.order.update + `/${id}`)
      return result
   }
   @action
   async updateStitches(productOrderId: string | number, params: { totalStitches?: number | null; newStitches?: number | null }) {
      const result = await Request2.postWithToken(params, api.order.updateStitches + `/${productOrderId}`)
      return result
   }
   @action
   async updateDraftOrder(
      id: string | number,
      trackingId: any,
      saigonId?: string,
      sellerOrderId?: string,
      note?: string,
      linkDesign?: string,
      linkMockup?: string,
      phone?: string,
      note1?: string,
      listProduct?: any[]
   ) {
      if (typeof trackingId === 'object' && trackingId !== null) {
         const result = await Request2.putWithToken(trackingId, api.draftOrder.update + `/${id}`)
         return result
      }

      let param = { trackingId, note, note1 }
      //@ts-ignore
      if (saigonId) {
         //@ts-ignore
         param.saigonId = saigonId
      }
      //@ts-ignore
      if (sellerOrderId) {
         //@ts-ignore
         param.sellerOrderId = sellerOrderId
      }

      if (linkDesign) {
         //@ts-ignore
         param.linkDesign = linkDesign
      }

      if (linkMockup) {
         //@ts-ignore
         param.linkMockup = linkMockup
      }

      if (phone) {
         //@ts-ignore
         param.phone = phone
      }

      if (listProduct && listProduct.length > 0) {
         //@ts-ignore
         param.listProduct = listProduct
      }
      const result = await Request2.putWithToken(param, api.draftOrder.update + `/${id}`)
      return result
   }
   @action
   async cancelOrder(id: string) {
      const result = await Request2.postWithToken({}, api.order.cancel + `/${id}`)
      return result
   }
   @action
   async confirmOrder(params: any) {
      const result = await Request2.postWithToken(params, api.order.confirm)
      return result
   }
   @action
   async confirmDraftOrder(id: string | number) {
      const result = await Request2.postWithToken({}, api.draftOrder.confirm.replace('id', `${id}`))
      return result
   }
   @action
   async confirmMultiDraftOrders(draftOrderIds: Array<string | number>) {
      const result = await Request2.postWithToken({ draftOrderIds }, api.draftOrder.confirmMulti)
      return result
   }

   @action
   async confirmCreateDelivery(params: any) {
      const result = await Request2.postWithToken(params, api.delivery.create)
      return result
   }

   @action
   async getPdf(params: any) {
      const result = await Request2.getFile(api.delivery.getPdf, { orderId: params })
      return result
   }

   @action
   async assigneeOrder(params: any) {
      const result = await Request2.postWithToken(params, api.order.assignee)
      return result
   }
   @action
   async assigneeDelivery(params: any) {
      const result = await Request2.postWithToken(params, api.delivery.create)
      return result
   }

   @action
   async updateStatusOrders(ids: any, statusFF: string) {
      const result = await Request2.postWithToken({ ids, statusFF }, api.order.updatesStatusFF)
      if (result?.code) {
         return result
      }
   }

   @action
   async updateDeliveryMaping(deliveryId: string, params: any) {
      const result = await Request2.postWithToken(params, api.delivery.productMaping + `/${deliveryId}`)
      return result
   }

   @action
   async importDeliveryMaping(deliveryId: string, file: File) {
      const result = await Request2.uploadFileWithToken(file, api.delivery.productMaping + `/${deliveryId}/import`)
      return result
   }

   @action
   async getListDeliveryMaping(deliveryId: string, params?: any) {
      const result = await Request2.getWithToken(api.delivery.productMaping + `/${deliveryId}`, params)
      if (result) {
         this.listShippingData = result
      } else {
         this.listShippingData = []
      }
      return result || []
   }

   @action
   resetListDeliveryMaping() {
      this.listShippingData = {}
   }
   @action
   setListDeliveryMaping(value: any) {
      this.resetListDeliveryMaping()
      this.listShippingData = { rows: [...value] }
   }
   @action
   async getDetail(id: any) {
      const result = await Request2.getWithToken(api.order.detail + `/${id}`)
      return result
   }
   @action
   async getDraftOrderDetail(id: any) {
      const result = await Request2.getWithToken(api.draftOrder.detail + `/${id}`)
      return result
   }

   @action
   async finishOrder(id: string, body: any) {
      const result = await Request2.postWithToken(body, api.order.finishOrder + `/${id}`)
      return result
   }

   @action
   async setSellerId(id: any) {
      if (this.sellerId == id) return (this.sellerId = null)

      this.sellerId = id
   }
   @action
   async setOrderList(list: any) {
      if (!list || list.length == 0) return
      this.orders = list
   }

   @action
   async exportExcel(param: any = {}) {
      const result = await Request2.getWithToken(api.order.exportExcel, { ...param })

      if (!isEmpty(result)) {
         this.dataExport = result
      }
   }
   async removeOrder(id: string) {
      const result = await Request2.postWithToken({}, api.order.removeOrder + `/${id}`)
      return result
   }
   async removeDraftOrder(id: string) {
      const result = await Request2.deleteWithToken({}, api.draftOrder.delete + `/${id}`)
      return result
   }

   @action
   async getShippingFee(params: any) {
      const result = await Request2.postWithToken(params, api.order.getShipingFee)

      if (!isEmpty(result)) {
         this.setShippingFee(result.data)
      }
   }

   @action
   setShippingFee(fee: number) {
      this.shippingFee = fee
   }

   @action
   async refundOrder(id: string) {
      const result = await Request2.postWithToken({}, api.order.refundOrder + `/${id}`)
      return result
   }
   @action
   async pushOrder(id: string) {
      const result = await Request2.postWithToken({}, api.order.pushOrder + `/${id}`)
      return result
   }
   @action
   async pushOrders(ids: any) {
      const result = await Request2.postWithToken({ orderIds: ids }, api.order.pushOrder)
      return result
   }

   @action
   async syncVNE(id: any) {
      const result = await Request2.getWithToken(api.order.getTrackingVNE + id)
      return result
   }

   @action
   async getListHistory(id: any) {
      const result = await Request2.getWithToken(api.order.getListHistory + `/${id}`)
      if (result) {
         this.listHistory = result
      } else {
         this.listHistory = []
      }
   }

   @action
   async getRoutingFW(params: any = {}) {
      const result = await Request2.getWithToken(api.delivery.webhook_FW_routing, params)
      return result
   }

   @action
   async updateStatusOrder(id: any, statusFF: string) {
      const result = await Request2.postWithToken({ statusFF }, api.order.updateStatusFF + `/${id}`)
      if (result?.code) {
         const dataTemp = { ...this.orders }
         const indexOrderId = findIndex(dataTemp?.rows, (o: any) => {
            return o?.id == id
         })

         if (indexOrderId >= 0) {
            if (this.orders?.rows?.[indexOrderId]) {
               const dataClone = [...this.orders?.rows]
               dataClone[indexOrderId].statusFF = statusFF

               this.orders.rows = [...dataClone]
            }
         }
      }
   }

   @action
   async getServiceDelivery(body: any) {
      const result = await Request2.postWithToken(body, api.order.lineShipPrice)
      if (result?.code) {
         return result?.data
      } else {
         return null
      }
   }

   @action
   async previewListOrder(body: any) {
      const result = await Request2.postWithToken(body, api.order.previewListOrder)
      return result
   }

   @action
   async previewListDrafOrder(body: any) {
      const result = await Request2.postWithToken(body, api.draftOrder.previewListOrder)
      return result
   }

   @action
   async insertMultiple(body: any) {
      const result = await Request2.postWithToken(body, api.order.importListOrder)
      return result
   }

   @action
   async insertMultipleDraftOrders(body: any[]) {
      const result = await Request2.postWithToken(body, api.draftOrder.importListOrder)
      return result
   }

   @action
   async calculateDraftPrice(params: any) {
      const result = await Request2.postWithToken(params, api.draftOrder.calculatePrice)
      return result
   }

   @action
   async getDeliveryPartnerList(keyword?: string) {
      const result = await Request2.getWithToken(api.deliveryPartner.getList, { keyword, limit: 200 })
      console.log('resultresultresultresult', result)

      if (result?.data?.length > 0) {
         return result?.data || []
      }
      return []
   }

   @action
   async createDeliveryPartner(body: any) {
      const result = await Request2.postWithToken(body, api.deliveryPartner.create)
      return result
   }
}
